<template>
  <div :class="$groupsStyle.enlargedContainer">
    <div :class="$groupsStyle.titleContainer">
      <div :class="$groupsStyle.titleText">
        {{ props.isPrelim ? $t('all-groups-prelim-votes') : $t('all-groups-saboteur-votes') }}
      </div>
      <div :class="$groupsStyle.actionsContainer">
        <div title="Close this box" :class="$groupsStyle.closeContainer" @click="props.closeAllGroupsCastVotes">
          <img :class="$groupsStyle.closeIcon" :src="closeIcon" alt="close" />
        </div>
      </div>
    </div>
    <div :class="$groupsStyle.bodyContainer">
      <div v-for="(group, index) in props.groups" :key="index" :class="$groupsStyle.groupContainer">
        <CastVoteBoxForHost
          :playersCount="group?.totalPlayersCount ?? null"
          :votesCasted="group?.votesCastedCount ?? null"
          :title="getGroupDisplayName(group, index, t)"
          :isPrelim="props.isPrelim"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
// import styles from "@/css/AllGroupsCastVotesBox.module.css";
import groupsStyles from "@/css/groupsUtil.module.css";
import CloseIcon from "@/assets/icons/close-red.svg";
import CastVoteBoxForHost from "./CastVoteBoxForHost.vue";
import { getGroupDisplayName } from "@/utils/functions";
import { useI18n } from "vue-i18n";

const { t } = useI18n();
// const $style = styles;
const $groupsStyle = groupsStyles;
const closeIcon = CloseIcon;

// eslint-disable-next-line
const props = defineProps({
  closeAllGroupsCastVotes: {
    type: Function,
    required: true,
  },
  groups: {
    type: Array,
    required: true,
  },
  isPrelim: {
    type: Boolean,
    required: false,
    default: false,
  },
});
</script>

<style scoped></style>
